import PageLoading from 'components/common/loading/PageLoading'
import { useAuth } from 'pages/authenticated/AuthContext'
import { ReactNode, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, validateToken } = useAuth()
  const location = useLocation()
  const [checking, setChecking] = useState(true)
  const [authorized, setAuthorized] = useState(false)

  useEffect(() => {
    let mounted = true
    const run = async () => {
      setChecking(true)
      const ok = await validateToken()
      if (!mounted) return
      setAuthorized(ok)
      setChecking(false)
    }
    void run()
    return () => {
      mounted = false
    }
  }, [validateToken, location.pathname, location.key])

  // Session dropped while still mounted on a protected page — never keep children.
  useEffect(() => {
    if (!isAuthenticated) {
      setAuthorized(false)
      setChecking(false)
    }
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />
  }

  if (checking) {
    return <PageLoading />
  }

  if (!authorized) {
    return <Navigate to="/auth" replace state={{ from: location }} />
  }

  return <>{children}</>
}

export default ProtectedRoute
